import "./Blog.module.css";
import Header from "@/reusable_sections/Header";
import BlogHero from "./sections/BlogHero";
import Insights from "./sections/Insights";
import Footer from "@/reusable_sections/Footer";
export default function BlogPage() {
  return <div>
      <Header />
      <BlogHero />
      <Insights />
      <Footer />
    </div>;
}